import { isMobile, isAndroid } from 'mobile-device-detect';
import type { NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router';
const isIframe = window.location !== window.parent.location;
const isLogged = !!localStorage.getItem('token') && !!localStorage.getItem('pin');

export default function auth(to: RouteLocationNormalized, from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
    if (isLogged || isIframe) return next();
    if (isMobile) {
        if (isAndroid) window.location.assign('aquaservice://');
        return next({ name: 'mobile' });
    }

    return next();
}
